import { Fragment } from "react";
import "./user_edit_profile.scss";

import UserEditProfileContentComponent from "../user_edit_profile/user_edit_profile_content_component/user_edit_profile_content_component";
import LoaderPopUp from "../../../components/loader/loader";

//Redux
import { connect } from "react-redux";
import Footer_component from "../structure_components/desktop_screens/footer_component/Footer_component";

const UserEditProfile = (props) => {
  let { loader, history, userPreference } = props;
  return (
    <Fragment>
      <div className="user_edit_profile_wrapper">
        <div className="user_edit_profile_inner_wrapper">
          <div className="user_edit_profile_right_wrapper">
            <UserEditProfileContentComponent
              userPreference={userPreference}
              history={history}
            />
          </div>
        </div>
        <Footer_component />
      </div>
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(UserEditProfile);
